<app-project-detail-mobile-list-item [title]="fileName" [expanded]="expanded" (toggle$)="onToggleExpand()">
  @if (!isReadOnlyUser) {
    <button
      mobileListActions
      odxButton
      class="menu-button"
      [odxMenu]="fileCardMenu"
      odxMenuPosition="bottom-end"
      (click)="$event.stopPropagation()"
      aria-label="Open file actions"
      i18n-aria-label="@@fileCard.button.openMenu"
    >
      <odx-icon name="more" size="large" aria-hidden="true"></odx-icon>
    </button>
  }

  <button
    mobileListBody
    type="button"
    class="file-placeholder"
    (click)="onDownload()"
    aria-label="Download file"
    i18n-aria-label="@@fileCard.button.downloadFile"
  >
    <odx-icon size="xlarge" [name]="setIcon()"></odx-icon>
  </button>
</app-project-detail-mobile-list-item>

<ng-template #fileCardMenu>
  <odx-menu>
    <button odxButton odxMenuItem (click)="$event.stopPropagation(); onDownload()">
      <odx-icon name="download" alignleft></odx-icon>
      <span i18n="@@global.download">Download</span>
    </button>

    <button odxButton odxMenuItem [disabled]="!hasWritePermission" (click)="$event.stopPropagation(); onDelete()">
      <odx-icon name="delete" alignleft></odx-icon>
      <span i18n="@@global.delete">Löschen</span>
    </button>
  </odx-menu>
</ng-template>
